import { format, parseISO } from "date-fns";
import { Weekday } from "mt-shared/db";

export const convertLocalToUtc = (date: Date | null) =>
  date ? new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000) : date;

const unixTimeToDate = (unixTime: string | number) =>
  new Date(Number(unixTime));

export const formatUnixTimeToDate = (unixTime: string | number) =>
  format(unixTimeToDate(unixTime), "yyyy-MM-dd HH:mm");

export const dateToComponents = (date: Date) => ({
  year: date.getFullYear(),
  month: String(date.getMonth() + 1).padStart(2, "0"),
  day: String(date.getDate()).padStart(2, "0"),
});

export const dateStringToComponents = (dateString: string) => {
  const [year, month, day] = dateString.split("-").slice(0, 3);
  return {
    year,
    month,
    day,
  };
};

export const unixTimeToComponents = (unixTime: string | number) =>
  dateToComponents(parseDateString(unixTime));

export const dateToDay = (date: Date | string) =>
  format(date, "EEEE") as Capitalize<Weekday>;

export const parseDateString = (dateString: string | number) =>
  (typeof dateString === "string" && /^\d+$/.test(dateString)) ||
  typeof dateString === "number"
    ? unixTimeToDate(dateString)
    : parseISO(dateString);
